import React from 'react';
import '../styles/Projects.css';
import ProjectCard from '../components/ProjectCard';
import useInView from '../hooks/useInView';

const projects = [
    { 
        title: 'Shades of Nüwa',
        date: 'October 2022',
        description: 'Developed core gameplay mechanics for a two-player platformer using Unity and C#, collaborating with a designer and artist to deliver a fully playable build under tight deadlines.'
    },
    { 
        title: 'Kickoff',
        date: 'December 2022',
        description: 'Database-driven application built with Java and Oracle, featuring user roles, query functionality, and statistical data analysis.'
    },
    {
        title: 'Mystique Makeup',
        date: 'November 2023',
        description: 'Full-stack web application built with React, TypeScript, and Firebase, featuring product browsing and appointment booking functionality.'
    },
    { 
        title: 'Agrohawk Web',
        date: 'May 2024',
        description: 'Client and service management web application built with React and Firebase, featuring real-time data updates and collaborative development using Git.' 
    },
    { 
        title: 'Diabetes & Anemia Prediction',
        date: 'November 2024',
        description: 'Machine learning application using Logistic Regression and KNN to predict medical conditions from Kaggle datasets, with model evaluation and performance tuning.'
    },
    { 
        title: 'Fitlight Virtual Test',
        date: 'May 2025',
        description: 'Interactive SPA built with React and Vite that measures user reaction time across five rounds and visualizes results using dynamic charts with Chart.js.'
    },
    { 
        title: 'Gestor de Ideas',
        date: 'May 2025',
        description: 'Full-stack web application that allows users to create, edit, delete, and filter ideas by tags. Built with React, Node.js, Express, and MongoDB to practice CRUD operations and backend integration.'
    }
];

const Projects = () => {
    const [ref, visible] = useInView({ rootMargin: '0px 0px -30% 0px', threshold: 0.08 });

    return (
        <div id='projects' ref={ref} className={`projects reveal ${visible ? 'visible' : ''}`}>

            <div className='subtitle'>
                <h2>{'Projects'}</h2>
            </div>

            <div className='projects-grid'>
                {projects.map((project) => (
                    <ProjectCard
                        key={project.title}
                        title={project.title}
                        date={project.date}
                        description={project.description}
                    />
                ))}
            </div>
        </div>
    );
}

export default Projects;